import {fabric} from "fabric";
import {initAligningGuidelines} from "./guideLines";

export const getFabricCanvas = async (sheet) => {
    let {height, width} = sheet.size;
    let {backgroundColor, zoom} = sheet;

    let canvas =  new fabric.Canvas("after-life-canvas", {
        selection: true,
        perPixelTargetFind: true,
        targetFindTolerance: 4,
        preserveObjectStacking: true,
        height: height,
        width: width,
        backgroundColor,
        fireRightClick: true
    });

    canvas.setZoom(zoom)
    canvas.setHeight(height * zoom);
    canvas.setWidth(width * zoom);
    canvas.renderAll();
    initAligningGuidelines(canvas)
    return canvas;
}


